import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import CarItemSkeletron from './carItem';
import './styles/carItemsList.scss';

const index = props => {
  const { size } = props;
  const carsTpl = [];
  for (let i = 0; i < size; i++) {
    carsTpl.push(
      <Col md={4} xs={12} key={i}>
        <CarItemSkeletron />
      </Col>,
    );
  }

  return (
    <div className="CarItemsListSkeletron">
      <Row>{carsTpl}</Row>
    </div>
  );
};

index.propTypes = {
  size: PropTypes.number.isRequired,
};

export default index;
